import { createSlice } from "@reduxjs/toolkit";

export const employerExtendRequest = createSlice({
  name: "employerExtendRequest",
  initialState: {
    pending: false,
    error: false,
    success: false,
  },
  reducers: {
    employerExtendRequestStart: (state, action) => {
      state.pending = true;
      state.error = false;
    },
    employerExtendRequestSuccess: (state, action) => {
      state.success = true;
      state.pending = false;
      state.error = false;
    },
    employerExtendRequestError: (state, action) => {
      state.pending = false;
      state.error = action.payload;
    },
  },
});

export const {
  employerExtendRequestStart,
  employerExtendRequestSuccess,
  employerExtendRequestError,
} = employerExtendRequest.actions;
export default employerExtendRequest.reducer;
